import React from 'react';

// Self-hosted fonts — no Google Fonts tracking
import '@fontsource/chakra-petch/400.css';
import '@fontsource/chakra-petch/500.css';
import '@fontsource/chakra-petch/600.css';
import '@fontsource/chakra-petch/700.css';
import '@fontsource/fira-code/400.css';
import '@fontsource/fira-code/600.css';
import '@fontsource/fira-code/700.css';

import "./src/styles/bootstrap-cusom.scss";
import AnalyticsNotice from './src/components/AnalyticsNotice';

// Wraps every page in a flex-column shell so the footer is always
// pushed to the bottom of the viewport regardless of content length.
export const wrapPageElement = ({ element }) => (
  <div className="site-shell">
    {element}
    <AnalyticsNotice />
  </div>
);
